const articles = [
  {
    category: 'Restaurant Finance',
    title: 'How to Calculate & Control Prime Cost in Your Virginia Restaurant',
    excerpt:
      'Prime cost (food + labor as a percentage of sales) is the single most important metric for restaurant profitability. Learn the industry benchmarks, how to track it weekly, and red flags that signal a pricing or scheduling problem.',
    readTime: '6 min read',
  },
  {
    category: 'Trades Business',
    title: 'Job Costing for Contractors: Why Most Small Trades Businesses Get It Wrong',
    excerpt:
      'Without per-project job costing, you are flying blind. We break down how to allocate labor, materials, equipment, and overhead to individual jobs — and why this changes everything about your pricing and profitability.',
    readTime: '8 min read',
  },
  {
    category: 'Virginia Compliance',
    title: 'Virginia Restaurant Tax Compliance: Meals Tax, Sales Tax & ABC Reporting',
    excerpt:
      'Virginia restaurants face a unique stack of tax obligations: state sales tax, local meals tax, and ABC reporting. Here is a practical guide to staying compliant across Richmond, Henrico, and Chesterfield jurisdictions.',
    readTime: '7 min read',
  },
  {
    category: 'Cash Flow',
    title: 'Cash Flow Forecasting for Seasonal Trades & Hospitality Businesses',
    excerpt:
      'Seasonal swings hit restaurants and trades hard. Learn how to build a simple but powerful 13-week cash flow forecast that helps you plan for slow months, equipment purchases, and hiring decisions with confidence.',
    readTime: '5 min read',
  },
];

export default function BlogTeaser() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">
              Insights & Resources
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-950 max-w-3xl mx-auto leading-tight">
              Knowledge for
              <span className="italic text-accent-600"> Smarter Decisions</span>
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
            {articles.map((article, i) => (
              <div
                key={i}
                className="group bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-accent-300/40 transition-all flex flex-col"
              >
                <span className="inline-flex items-center gap-1.5 bg-accent-100 text-accent-700 text-xs font-semibold px-2.5 py-1 rounded-full mb-4 w-fit">
                  {article.category}
                </span>
                <h3 className="font-heading text-base md:text-lg text-primary-950 font-semibold mb-3 leading-snug group-hover:text-accent-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed flex-1 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-background-200/60">
                  <span className="text-foreground-400 text-xs">{article.readTime}</span>
                  <span className="text-accent-600 text-xs font-semibold flex items-center gap-1">
                    Coming Soon
                    <i className="ri-time-line" />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}